export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const LOCATE_AMBULANCE = "LOCATE_AMBULANCE";
export const CLEAR_SOS_FORM = "CLEAR_SOS_FORM";
export const LOCATE_AMBULANCE_BY_LOCATION = "LOCATE_AMBULANCE_BY_LOCATION";
export const LOCATE_TRAUMACENTER_BY_LOCATION =
  "LOCATE_TRAUMACENTER_BY_LOCATION";
export const LOCATE_POLICESTATION_BY_LOCATION =
  "LOCATE_POLICESTATION_BY_LOCATION";
export const LAT_LNG = "LAT_LNG";
export const GET_MANUFACTURER_EMPANELMENT_DETAIL =
  "GET_MANUFACTURER_EMPANELMENT_DETAIL";
export const GET_EMPANELMENT_DETAIL = "GET_EMPANELMENT_DETAIL";
export const GET_SOFTWARE_NOTIFICATION = "GET_SOFTWARE_NOTIFICATION";
export const GET_EMPANELMENT_DOCUMENT = "GET_EMPANELMENT_DOCUMENT";
export const ACCOUNT_SUSPENSION = "ACCOUNT_SUSPENSION";
export const POPUP_CLOSE_MASTER = "POPUP_CLOSE_MASTER";
export const SET_SOFTWARE_NOTIFICATION = "SET_SOFTWARE_NOTIFICATION";
export const GET_ACCOUNTS_TYPE = "GET_ACCOUNTS_TYPE";
export const GET_ROLES_TYPE = "GET_ROLES_TYPE";
export const GET_MESSAGE_TYPE = "GET_MESSAGE_TYPE";
export const ACCOUNT_NOTIFICATION = "ACCOUNT_NOTIFICATION";
export const ACCOUNT_NOTIFICATION_TABLE = "ACCOUNT_NOTIFICATION_TABLE";
export const NOTIFICATION_API = "NOTIFICATION_API";
export const UPDATE_SOFTWARE_NOTIFICATION = "UPDATE_SOFTWARE_NOTIFICATION";
export const SOFTWARE_NOTIFICATION = "SOFTWARE_NOTIFICATION";
export const GET_BOOKED_TESTING_SLOT = "GET_BOOKED_TESTING_SLOT";
export const GET_EMPANELMENT_DEVICE = "GET_EMPANELMENT_DEVICE";
export const GET_EMPANELMENT_TIME_SLOTS = "GET_EMPANELMENT_TIME_SLOTS";
export const CHECK_EMPANELMENT_SLOT_TYPE = "CHECK_EMPANELMENT_SLOT_TYPE";
export const MANUFACTURER_EMPANELMENT_SLOT = "MANUFACTURER_EMPANELMENT_SLOT";
export const GET_EMPANELMENT_DOCUMENTS = "GET_EMPANELMENT_DOCUMENTS";
export const GET_EMPANELMENT_DOCUMENT_TYPES = "GET_EMPANELMENT_DOCUMENT_TYPES";
export const GET_INSTALLATION_DETAIL = "GET_INSTALLATION_DETAIL";
export const GET_NETWORK_PROVIDERS = "GET_NETWORK_PROVIDERS";
export const UPDATE_NETWORK_PROVIDERS_STATUS =
  "UPDATE_NETWORK_PROVIDERS_STATUS";
export const UPDATE_NETWORK_PROVIDERS = "UPDATE_NETWORK_PROVIDERS";
export const ADD_NETWORK_PROVIDERS = "ADD_NETWORK_PROVIDERS";
export const GET_TESTING_AGENCIES = "GET_TESTING_AGENCIES";
export const UPDATE_TESTING_AGENCY_STATUS = "UPDATE_TESTING_AGENCY_STATUS";
export const GET_BG_WALLET_LIST = "GET_BG_WALLET_LIST";
export const GET_BG_WALLET_ADD_ON = "GET_BG_WALLET_ADD_ON";
export const UPDATE_TESTING_AGENCY = "UPDATE_TESTING_AGENCY";
export const ADD_TESTING_AGENCY = "ADD_TESTING_AGENCY";
export const GET_ALERT_RULES = "GET_ALERT_RULES";
export const UPDATE_ALERT_RULE_STATUS = "UPDATE_ALERT_RULE_STATUS";
export const EDIT_ALERT_RULE = "EDIT_ALERT_RULE";
export const GET_ORGANIZATION_TYPE = "GET_ORGANIZATION_TYPE";
export const UPDATE_ORGANIZATION_TYPE_STATUS =
  "UPDATE_ORGANIZATION_TYPE_STATUS";
export const SET_ORGANIZATION_TYPE = "SET_ORGANIZATION_TYPE";
export const GET_TICKET_SUBJECT = "GET_TICKET_SUBJECT";
export const UPDATE_TICKET_SUBJECT_STATUS = "UPDATE_TICKET_SUBJECT_STATUS";
export const SET_TICKET_SUBJECT = "SET_TICKET_SUBJECT";
export const GET_PRIORITY_TYPE = "GET_PRIORITY_TYPE";
export const GET_AMBULANCES = "GET_AMBULANCES";
export const UPDATE_AMBULANCE_STATUS = "UPDATE_AMBULANCE_STATUS";
export const SET_AMBULACE = "SET_AMBULACE";
export const OVERSPEED_DATA = "OVERSPEED_DATA";
export const GET_BG_WALLET_TRANSACTIONS = "GET_BG_WALLET_TRANSACTIONS";
export const GET_NEWS_UPDATE = "GET_NEWS_UPDATE";
export const UPDATE_NEWS_UPDATE_STATUS = "UPDATE_NEWS_UPDATE_STATUS";
export const SET_NEWS_UPDATE = "SET_NEWS_UPDATE";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_LIVE_PORTS = "GET_LIVE_PORTS";
export const UPDATE_LIVE_PORTS_STATUS = "UPDATE_LIVE_PORTS_STATUS";
export const SET_LIVE_PORTS = "SET_LIVE_PORTS";
export const GET_LISTENER_TYPE = "GET_LISTENER_TYPE";
export const UPDATE_M2M_SERVICE_PROVIDER = "UPDATE_M2M_SERVICE_PROVIDER";
export const ADD_M2M_SERVICE_PROVIDER = "ADD_M2M_SERVICE_PROVIDER";
export const GET_M2M_SERVICE_PROVIDER = "GET_M2M_SERVICE_PROVIDER";
export const UPDATE_M2M_SERVICE_PROVIDER_STATUS =
  "UPDATE_M2M_SERVICE_PROVIDER_STATUS";
export const SET_DEVICE_PROTOCOL_PORT = "SET_DEVICE_PROTOCOL_PORT";
export const GET_DEVICE_PROTOCOL_PORTS = "GET_DEVICE_PROTOCOL_PORTS";
export const UPDATE_TAC_PORT_STATUS = "UPDATE_TAC_PORT_STATUS";
export const UPDATE_LISTENER_PORT_AT = "UPDATE_LISTENER_PORT_AT";
export const GET_SERVER_CONFIGURATION = "GET_SERVER_CONFIGURATION";
export const GET_SERVER_INSTANCES = "GET_SERVER_INSTANCES";
export const GET_SIM_TYPES = "GET_SIM_TYPES";
export const GET_SIM_TYPE_PROFILE = "GET_SIM_TYPE_PROFILE";
export const GET_SIM_TYPE_NETWORK = "GET_SIM_TYPE_NETWORK";
export const UPDATE_SIM_TYPE = "UPDATE_SIM_TYPE";
export const UPDATE_SIM_TYPE_PROFILE = "UPDATE_SIM_TYPE_PROFILE";
export const UPDATE_SIM_TYPE_NETWORK = "UPDATE_SIM_TYPE_NETWORK";
export const ADD_SIM_TYPE = "ADD_SIM_TYPE";
export const ADD_SIM_TYPE_PROFILE = "ADD_SIM_TYPE_PROFILE";
export const ADD_SIM_TYPE_NETWORK = "ADD_SIM_TYPE_NETWORK";
export const UPDATE_SIM_TYPE_STATUS = "UPDATE_SIM_TYPE_STATUS";
export const Add_BG_WALLET = "Add_BG_WALLET";
export const Add_BG_WALLET_PANELTY = "Add_BG_WALLET_PANELTY";
export const GET_BG_WALLET_STATUS = "GET_BG_WALLET_STATUS";
export const GET_DOCUMENTS_TYPE = "GET_DOCUMENTS_TYPE";
export const UPDATE_SIM_TYPE_STATUS_PROFILE = "UPDATE_SIM_TYPE_STATUS_PROFILE";
export const UPDATE_SIM_TYPE_STATUS_NETWORK = "UPDATE_SIM_TYPE_STATUS_NETWORK";
export const GET_TRAUMA_CENTERS = "GET_TRAUMA_CENTERS";
export const UPDATE_TRAUMA_CENTERS_STATUS = "UPDATE_TRAUMA_CENTERS_STATUS";
export const SET_TRAUMA_CENTERS = "SET_TRAUMA_CENTERS";
export const GET_DISTRICT = "GET_DISTRICT";
export const GET_DISTRICT_GEOFENCE = "GET_DISTRICT_GEOFENCE";
export const GET_MANAGE_ROLES = "GET_MANAGE_ROLES";
export const GET_MANAGE_USERS = "GET_MANAGE_USERS";
export const GET_CITIZEN_USERS = "GET_CITIZEN_USERS";
export const GET_DEVICES = "GET_DEVICES";
export const GET_MANAGE_DEVICES = "GET_MANAGE_DEVICES";
export const GET_DEVICES_VERIFICATION = "GET_DEVICES_VERIFICATION";
export const GET_MEMBER_LIST = "GET_MEMBER_LIST";
export const GET_MODELS_TYPE = "GET_MODELS_TYPE";
export const GET_BG_TRANSACTION_STATUS = "GET_BG_TRANSACTION_STATUS";
export const GET_BG_TRANSACTION_TYPE = "GET_BG_TRANSACTION_TYPE";
export const GET_BG_WALLET_ADD_ON_EXPORT = "GET_BG_WALLET_ADD_ON_EXPORT";
export const GET_BG_WALLET_TRANSACTION_EXPORT =
  "GET_BG_WALLET_TRANSACTION_EXPORT";
export const GET_VEHICLE_TYPES = "GET_VEHICLE_TYPES";
export const GET_RTO = "GET_RTO";
export const GET_INSTALLED_STATS = "GET_INSTALLED_STATS";
export const GET_RFC_TYPE = "GET_RFC_TYPE";
export const GET_TICKET_DETAIL_LIST = "GET_TICKET_DETAIL_LIST";
export const GET_CUSTOMER_TICKET_DETAIL_LIST =
  "GET_CUSTOMER_TICKET_DETAIL_LIST";
export const GET_CUSTOMER_TICKET_DETAIL_LIST_API =
  "GET_CUSTOMER_TICKET_DETAIL_LIST_API";
export const GET_CUSTOMER_VEHICLE_DETAIL = "GET_CUSTOMER_VEHICLE_DETAIL";
export const GET_CUSTOMER_VEHICLE_LIST = "GET_CUSTOMER_VEHICLE_LIST";
export const GET_OFFLINE_INTIMATION = "GET_OFFLINE_INTIMATION";
export const GET_VEHICLE_OWNER_NOTIFICATION = "GET_VEHICLE_OWNER_NOTIFICATION";
export const MARK_VEHICLE_OWNER_NOTIFICATION_READ =
  "MARK_VEHICLE_OWNER_NOTIFICATION_READ";
export const GET_EMPANELMENT_PROCESS = "GET_EMPANELMENT_PROCESS";
export const GET_SYSTEM_LOG = "GET_SYSTEM_LOG";
export const GET_RTO_VLTD_INSTALLATION_REPORT =
  "GET_RTO_VLTD_INSTALLATION_REPORT";
export const GET_VLTD_INSTALLATION_REPORT = "GET_VLTD_INSTALLATION_REPORT";
export const GET_RFC_VLTD_INSTALLATION_REPORT =
  "GET_RFC_VLTD_INSTALLATION_REPORT";
export const GET_DEVICE_STATUS_REPORT = "GET_DEVICE_STATUS_REPORT";
export const GET_RTO_VERIFICATION_DEVICE_REPORT =
  "GET_RTO_VERIFICATION_DEVICE_REPORT";
export const GET_DEVICE_AUDIT_REPORT = "GET_DEVICE_AUDIT_REPORT";
export const GET_DEVICE_OFFLINE_INTIMATION_REPORT =
  "GET_DEVICE_OFFLINE_INTIMATION_REPORT";
export const GET_SIM_MANUFACTURER_ACTIVITIES =
  "GET_SIM_MANUFACTURER_ACTIVITIES";
export const GET_GEOFENCE_ALERT_REPORT = "GET_GEOFENCE_ALERT_REPORT";
export const GET_ROUTEFENCE_ALERT_REPORT = "GET_ROUTEFENCE_ALERT_REPORT";
export const GET_TICKET_PERFORMANCE_STATS_REPORT =
  "GET_TICKET_PERFORMANCE_STATS_REPORT";
export const GET_DEVICE_OVERSPEED_REPORT = "GET_DEVICE_OVERSPEED_REPORT";
export const GET_DEVICE_PANIC_HISTORY_REPORT =
  "GET_DEVICE_PANIC_HISTORY_REPORT";
export const GET_NONWORKING_SLOT_ALERT_REPORT =
  "GET_NONWORKING_SLOT_ALERT_REPORT";
export const GET_DEVICE_HEALTH_REPORT = "GET_DEVICE_HEALTH_REPORT";
export const GET_DEVICE_ALERT_REPORT = "GET_DEVICE_ALERT_REPORT";
export const GET_ALERT_TYPES = "GET_ALERT_TYPES";
export const GET_EMP_DOC_REJECTED_REPORT = "GET_EMP_DOC_REJECTED_REPORT";
export const GET_UNMAP_DEVICE_REPORT = "GET_UNMAP_DEVICE_REPORT";
export const GET_EMAIL_ACTIVITIES_REPORT = "GET_EMAIL_ACTIVITIES_REPORT";
export const GET_INSUFFICIENT_STOCK_REPORT = "GET_INSUFFICIENT_STOCK_REPORT";
export const GET_SERVER_LOGS = "GET_SERVER_LOGS";
export const GET_USER_ACTIVITIES = "GET_USER_ACTIVITIES";
export const GET_ERSS_SIGNAL_LOGS = "GET_ERSS_SIGNAL_LOGS";
export const GET_INSTALLATION_DEVICE_REPORT = "GET_INSTALLATION_DEVICE_REPORT";
export const GET_ROLE_TYPE = "GET_ROLE_TYPE";
export const GET_GLOBAL_SERVER_LOGS = "GET_GLOBAL_SERVER_LOGS";
export const GET_MANAGE_ROLES_FORM = "GET_MANAGE_ROLES_FORM";
export const GET_POI_CATEGORIES = "GET_POI_CATEGORIES";
export const ADD_POI_CATEGORIES = "ADD_POI_CATEGORIES";
export const UPDATE_POI_CATEGORIES_STATUS = "UPDATE_POI_CATEGORIES_STATUS";
export const GET_POI_SUB_CATEGORIES = "GET_POI_SUB_CATEGORIES";
export const ADD_POI_SUB_CATEGORIES = "ADD_POI_SUB_CATEGORIES";
export const UPDATE_POI_SUB_CATEGORIES_STATUS =
  "UPDATE_POI_SUB_CATEGORIES_STATUS";
export const GET_POI = "GET_POI";
export const ADD_POI = "ADD_POI";
export const ADD_POI_SUB = "ADD_POI_SUB";
export const UPDATE_POI_STATUS = "UPDATE_POI_STATUS";
export const GET_POI_SUB = "GET_POI_SUB";
export const UPDATE_POI_SUB_STATUS = "UPDATE_POI_SUB_STATUS";
export const GET_POI_TYPE = "GET_POI_TYPE";
export const GET_POI_SUB_TYPE = "GET_POI_SUB_TYPE";
export const UPDATE_POI_ICON = "UPDATE_POI_ICON";
export const GET_OFFLINE_DEVICE_HISTORY_REPORT =
  "GET_OFFLINE_DEVICE_HISTORY_REPORT";
export const GET_INVALID_VLTD_ONLINE_REPORT = "GET_INVALID_VLTD_ONLINE_REPORT";
export const GET_INVALID_TICKET_REPORT = "GET_INVALID_TICKET_REPORT";
export const LOCATE_POI_BY_LOCATION = "LOCATE_POI_BY_LOCATION";
export const GET_INTIMATION_DOC_TYPES = "GET_INTIMATION_DOC_TYPES";
export const GET_RTO_REVERIFICATION_REPORT = "GET_RTO_REVERIFICATION_REPORT";
export const GET_ALERT_TYPE = "GET_ALERT_TYPE";
export const UPDATE_ALERT_TYPE_STATUS = "UPDATE_ALERT_TYPE_STATUS";
export const SET_ALERT_TYPE_STATUS = "SET_ALERT_TYPE_STATUS";
export const GET_DEVICE_CUMULATIVE_OVERSPEED_REPORT =
  "GET_DEVICE_CUMULATIVE_OVERSPEED_REPORT";
export const TICKET_PANELTY_SETTLEMENT = "TICKET_PANELTY_SETTLEMENT";
export const GET_VEHICLE_ICON = "GET_VEHICLE_ICON";
export const GET_DEVICE_PANIC_HISTORY_CUMULATIVE_REPORT =
  "GET_DEVICE_PANIC_HISTORY_CUMULATIVE_REPORT";
export const SOFTWARE_NOTIFICATION_REPORT = "SOFTWARE_NOTIFICATION_REPORT";
export const UNREAD_SOFTWARE_NOTIFICATION = "UNREAD_SOFTWARE_NOTIFICATION";
export const SET_READ_SOFTWARE_NOTIFICATION = "SET_READ_SOFTWARE_NOTIFICATION";
export const GET_OFFLINE_DEVICE_MONTHLY_REPORT =
  "GET_OFFLINE_DEVICE_MONTHLY_REPORT";
export const GET_PACKAGE_SETTING = "GET_PACKAGE_SETTING";
export const GET_ESTIMATED_TIME_DISTANCE = "GET_ESTIMATED_TIME_DISTANCE";
export const GET_STATE_GEOFENCE = "GET_STATE_GEOFENCE";
export const GET_EXPIRED_INSTALLATION_REPORT =
  "GET_EXPIRED_INSTALLATION_REPORT";
